"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Kenten = {
    elemName: '圏点',
    type: 'inline',
    doc: '圏点を打たれたテキストをタグ付けします。第1要素はテキスト本体、第2要素には「○」など圏点に利用される記号を入力します。',
    example: '《圏点：圏点を打たれた文章｜﹅》',
    minContentCount: 1,
    maxContentCount: 2,
    textTemplate: '{{$text}}',
    htmlTemplate: `
    <span {{{$htmlId}}} class="Kenten {{$classes}}"
    {{#$2}}
    style="text-emphasis: '{{$2}}'; -webkit-text-emphasis: '{{$2}}'"
    {{/$2}}         
    >
        {{{$1}}}
    </span>`,
    xmlTemplate: `<emph>{{{$1}}}</emph>`,
    docxTemplate: `
	<w:r>
            <w:rPr>
                <w:em w:val="dot"/>
            </w:rPr>
            <w:t>{{{$$1}}}</w:t>
    </w:r>
	`,
    latexTemplate: "\\bou{ {{{$1}}} }"
};
exports.default = Kenten;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS2VudGVuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnZlcnRlci9pbmxpbmVfcnVsZXMvS2VudGVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxNQUFNLEdBQW1CO0lBQzNCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFFBQVE7SUFDZCxHQUFHLEVBQUUsOERBQThEO0lBQ25FLE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFdBQVc7SUFDekIsWUFBWSxFQUFFOzs7Ozs7O1lBT047SUFDUixXQUFXLEVBQUUsdUJBQXVCO0lBQ3BDLFlBQVksRUFBRTs7Ozs7OztFQU9oQjtJQUNFLGFBQWEsRUFBRSxtQkFBbUI7Q0FDckMsQ0FBQztBQUVGLGtCQUFlLE1BQU0sQ0FBQyJ9